'use strict'

import { TweenMax } from 'gsap';
import { isBrowser } from './helpers'

const notifications = {

  /**
   * Checks is current browser unsupported legacy version.
   *
   * @return {Boolean} True if browser is legacy.
   */
  isLegacyBrowser: () => {
    // IE11 detection: https://stackoverflow.com/a/21825207
    return isBrowser.IE11 || window.localStorage.getItem('devLegacyBrowser') === '1';
  },

  /**
   * Initialize notifications.
   */
  init: function () {
    const notificationContainer = document.getElementById('notifications');
    const notifications = notificationContainer.querySelectorAll('.notification');

    notifications.forEach(notification => {
      const remove = () => {
        if (notification.parentElement) {
          notification.parentElement.removeChild(notification);
        }
      };

      // Remove notification if it should not be shown
      if (notification.id === 'cookie-notification' && window.localStorage.getItem('cookieNotice') === '1' ||
        notification.id === 'legacy-browser-notification' && (window.sessionStorage.getItem('legacyBrowserNotice') === '1' || !this.isLegacyBrowser())) {
        remove()
        return;
      }

      const button = notification.querySelector('[data-notification-close]');
      button.addEventListener('click', () => {
        if (notification.id === 'cookie-notification') {
          window.localStorage.setItem('cookieNotice', '1');
        }
        else if (notification.id === 'legacy-browser-notification') {
          window.sessionStorage.setItem('legacyBrowserNotice', '1');
        }
        TweenMax.to(notification, 0.5, { opacity: 0, onComplete: remove });
      });

      notificationContainer.classList.add('has-visible-notifications');
    });
  }
};

module.exports = notifications;
